import React, {Component} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {Map} from "immutable";
import {ProgressBar} from "@blueprintjs/core";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";

// Components
import ReceiptDetail from "./ReceiptDetail";
import ReceiptFiles from './ReceiptFiles';
import DeleteDialog from '../../../components/dialogs/DeleteDialog';

// Actions
import {
    getReceipt,
    updateReceipt,
    uploadReceiptFiles,
    downloadReceiptFile,
    deleteReceiptFile,
    deleteReceipt,
    cleanReceipts
} from "../../../actions/receipts";
import {addNotification} from "../../../actions/notifications";


class ReceiptTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: this.getSelectedIndex(),
            editMode: false,
            canSubmit: false,
            status: '',
            // modal
            modalIsOpen: false,
            modalType: null
        };

        this.getSelectedIndex = this.getSelectedIndex.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }
    componentDidMount() {
        this.props.getReceipt(this.props.match.params.receiptId);
    }
    componentWillUnmount() {
        this.props.cleanReceipts();
    }

    // Tab handlers
    getSelectedIndex() {
        const {receiptId} = this.props.match.params;

        // Check if any child route is active. As last step, check if principal route is active to assign default tab index.
        switch (this.props.history.location.pathname) {
            case '/compras/albaranes/' + receiptId + '/detalle':
                return 0;
            case '/compras/albaranes/' + receiptId + '/ficheros':
                return 1;
            default:
                return 0;
        }
    }
    handleTabChange(index, lastIndex, event) {
        const {receiptId} = this.props.match.params;
        let route = '';

        switch (index) {
            case 0:
                route = '/compras/albaranes/' + receiptId + '/detalle';
                break;
            case 1:
                route = '/compras/albaranes/' + receiptId + '/ficheros';
                break;
            default:
                break;
        }

        this.props.history.push(route);
        this.setState({
            tabIndex: this.getSelectedIndex()
        });
    }

    // ReceiptDetail handlers
    handleEditClick = () => {
        this.setState({
            editMode: true
        });
    };
    handleCancelClick = () => {
        this.child.updateReceiptsState();
        this.setState({
            editMode: false,
            canSubmit: false
        });
    };
    handleSaveClick = () => {
        this.child.updateReceipt();
        this.setState({
            editMode: false
        });
    };
    canSubmit = (canSubmit) => {
        this.setState({ canSubmit })
    };

    // Modal handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false
        })
    };

    render() {
        const { tabIndex, editMode, canSubmit } = this.state;

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'deleteDialog':
                    modal = {
                        width: 'medium',
                        title: 'Borrar albaran de entrega',
                        body: (
                            <DeleteDialog
                                text={ this.props.receipt.get('receipt_code') }
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="delete"
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={ () => {
                                        this.props.deleteReceipt(this.props.receipt.get('_id'));
                                        this.closeModal();
                                        this.props.history.push('/compras/albaranes');
                                    }}
                                >
                                    {'Borrar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (

            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/compras/resumen">Compras</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/compras/albaranes">Albaranes</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>{ this.props.receipt.get('receipt_code') }</strong>
                            </li>
                        </ol>
                    </div>
                    { this.props.uploadProgress.get('isUploading')
                        ? <div className="col d-flex align-items-center justify-content-end">
                            <ProgressBar
                                intent="PRIMARY"
                                value={ this.props.uploadProgress.get('percent') } />
                        </div>
                        : null
                    }
                    { tabIndex === 0
                        ? (
                            <div className="col d-flex align-items-center justify-content-end">
                                {!editMode
                                    ? <div className="title-action">
                                        { this.props.receipt.get('can_delete')
                                                ? <button
                                                    className="btn btn-danger"
                                                    onClick={ () => this.openModal('deleteDialog') }
                                                >Borrar</button>
                                                : null
                                        }
                                        <button className="btn btn-custom" onClick={this.handleEditClick}>Editar</button>
                                    </div>
                                    : <div className="title-action">
                                        <button className="btn btn-cancel" onClick={this.handleCancelClick}>Cancelar</button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.handleSaveClick}
                                            disabled={!canSubmit}
                                        >Guardar
                                        </button>
                                    </div>
                                }
                            </div>
                        ) : ''
                    }
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="tabs-container">
                                { this.props.receipt.get('_id')
                                    ? (
                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={this.handleTabChange}
                                    selectedTabPanelClassName="active show"
                                >
                                    <TabList className="nav nav-tabs">
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 0})}>Detalle</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 1})}>Ficheros</Link>
                                        </Tab>
                                    </TabList>
                                    <div className="tab-content">
                                        <TabPanel className="tab-pane">
                                            { this.props.receipt.get('_id')
                                                ? <ReceiptDetail
                                                    onRef={ref => (this.child = ref)}
                                                    editMode={this.state.editMode}
                                                    canSubmit={this.canSubmit}
                                                    receipt={this.props.receipt}
                                                    updateReceipt={this.props.updateReceipt}
                                                />
                                                : null
                                            }
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            <ReceiptFiles
                                                receipt={this.props.receipt}
                                                uploadReceiptFiles={this.props.uploadReceiptFiles}
                                                uploadProgress={this.props.uploadProgress}
                                                downloadReceiptFile={this.props.downloadReceiptFile}
                                                deleteReceiptFile={this.props.deleteReceiptFile}
                                                addNotification={this.props.addNotification}
                                            />
                                        </TabPanel>
                                    </div>
                                </Tabs>
                                        )
                                        : null
                                    }
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const receiptReducer = state.receipts;

    // Receipt
    let receipt = receiptReducer.get('payload') || Map({});

    if (!(receipt instanceof Map)) {
        receipt = Map({})
    }

    // Upload Progress
    const uploadProgress = Map({
        isUploading: receiptReducer.get('isUploading') || false,
        percent: receiptReducer.get('percent') || 0
    });

    return {
        receipt,
        uploadProgress
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getReceipt: (receiptId) => dispatch(getReceipt(receiptId)),
        updateReceipt: (receiptId, receipt) => dispatch(updateReceipt(receiptId, receipt)),
        uploadReceiptFiles: (receiptId, files) => dispatch(uploadReceiptFiles(receiptId, files)),
        downloadReceiptFile: (receiptId, fileId) => dispatch(downloadReceiptFile(receiptId, fileId)),
        deleteReceiptFile: (receiptId, fileId) => dispatch(deleteReceiptFile(receiptId, fileId)),
        deleteReceipt: (receiptId) => dispatch(deleteReceipt(receiptId)),
        cleanReceipts: () => dispatch(cleanReceipts()),
        addNotification: (notification) => dispatch(addNotification(notification))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReceiptTabs);



// WEBPACK FOOTER //
// ./src/containers/purchases/receipts/ReceiptTabs.js